import { useState, useEffect, useContext } from "react"
import { DataGrid } from "@mui/x-data-grid"
import axios from "axios"
import { Link as RouterLink, useNavigate } from "react-router-dom"
import TextField from "@mui/material/TextField"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import Alert from "@mui/material/Alert"
import Snackbar from "@mui/material/Snackbar"
import AuthContext from "../../AuthContext"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { API_URL } from "../../config"
export default function AdminCustomerPanel({
  className,
  title,
  content,
  ...props
}) {
  const [pageSize, setPageSize] = useState(10)
  const { token } = useContext(AuthContext)
  const [rows, setRows] = useState([])
  const [filter, setFilter] = useState("Pending")
  const [showSnackbar, setShowSnackbar] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(false)
  const [s, setS] = useState(1)
  // for changing email
  const [account, setAccount] = useState("") 
  const [email, setEmail] = useState("") 
  const reload = () => {
    setS(s * -1)
  }

  const getFields = (params) => {
    const api = params.api

    const fields = api
    .getAllColumns()
    .map((c) => c.field)
    .filter((c) => c !== "__check__" && !!c)
    const thisRow = {}

    fields.forEach((f) => {
      thisRow[f] = params.row[f]
    })

    return thisRow
  }
  const updatedField = (field, previousField) => {
    if (previousField != null && previousField != field) {
      return (
        <>
          {field}
          <br />
          <s style={{ color: "grey" }}>{previousField}</s>
        </>
      )
    } else {
      return field
    }
  }
  const setCompleted = (id, completed) => {
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, completed } : row))
    )
  }

  const handleFilterChange = (event) => {
    setFilter(event.target.value)
  }

  const changeEmail = (e) => {
    e.stopPropagation()
    axios
      .post(
        `${API_URL}/customer/change_email`,
        {
          account: account,
          email: email,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        alert(
          `Email of ${account} has been changed to '${email}'`
        );
        setAccount("")
        setEmail("")
      })
      .catch((err) => {
        alert(`Failed to change the email of ${account} invalid, ${err}`)
      })
  }

  useEffect(() => {
    if (token) {
      let url = `${API_URL}/customer/requests`
      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          response.data.forEach((item, i) => {
            item.id = i + 1
          })
          setRows(response.data)
        })
        .catch((error) => {
          console.error("Error fetching account requests:", error)
        })
    } else {
      console.error("No token available")
    }
  }, [token, s])

  const filteredRows = rows.filter((row) => {
    if (row.status === "Pending" && filter === "Pending") {
      return true
    } else if (row.status !== "Pending" && filter === "Completed") {
      return true
    } else if (filter === "Show All") {
      return true
    }

    return false
  })

  return (
    <div {...props} id="requests">
      <Box
        sx={{
          marginBottom: 2,
          display: "flex",
          gap: 2,
          justifyContent: "space-between",
        }}
      >
        <p>Account Requests</p>
      </Box>
      <Box sx={{ marginBottom: 2, display: "flex", gap: 2 }}>
        <Select value={filter} onChange={handleFilterChange} displayEmpty>
          <MenuItem value="Pending">
            <em>Pending</em>
          </MenuItem>
          <MenuItem value="Completed">
            <em>Completed</em>
          </MenuItem>
          <MenuItem value="Show All">
            <em>Show All</em>
          </MenuItem>
        </Select>
      </Box>
      <div style={{ height: 600, width: "100%" }}>
        <DataGrid
          style={{ cursor: "pointer" }}
          rows={filteredRows}
          rowHeight={50}
          initialState={{
            columns: {
              columnVisibilityModel: {
                request_id: false,
              },
            },
          }}
          columns={[
            {
              field: "request_id",
              headerName: "Request ID",
              width: 110,
              editable: false,
            },
            {
              field: "acc_code",
              headerName: "A/C No.",
              width: 80,
              editable: true,
            },
            {
              field: "email",
              headerName: "Email",
              width: 250,
              editable: true,
              renderCell: (params) => {
                return updatedField(params.row.email, params.row.previous_email)
              },
            },
            {
              field: "first_name",
              headerName: "Name",
              width: 90,
              editable: true,
              renderCell: (params) => {
                return updatedField(
                  params.row.first_name,
                  params.row.previous_first_name
                )
              },
            },
            {
              field: "company",
              headerName: "Company",
              width: 240,
              editable: true,
            },
            {
              field: "contact_number",
              headerName: "Contact Number",
              width: 140,
              editable: true,
              renderCell: (params) => {
                const link = `tel:${params.row.contact_number}`
                return <a href={link}>{params.row.contact_number}</a>
              },
            },
            {
              field: "status",
              headerName: "Status",
              width: 140,
            },
            {
              field: "completed",
              headerName: "Action",
              width: 200,
              renderCell: (params) => {
                const accept = (e) => {
                  e.stopPropagation()
                  setCompleted(params.row.id, true)
                  const thisRow = getFields(params)

                  axios
                    .post(
                      `${API_URL}/customer/requests/${thisRow.request_id}/accept`,
                      {
                        request_id: thisRow.request_id,
                        acc_code: thisRow.acc_code,
                        email: thisRow.email,
                        first_name: thisRow.first_name,
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    )
                    .then(() => {
                      setSnackbarMessage(
                        `Request has been accepted, sending registration email to ${params.row.email}`
                      )
                      setShowSnackbar(true)
                      reload()
                    })
                    .catch((err) => {
                      alert(`The email ${thisRow.email} is invalid, ${err}`)
                    })
                }

                const reject = (e) => {
                  e.stopPropagation()
                  setCompleted(params.row.id, true)
                  const thisRow = getFields(params)

                  axios
                    .post(
                      `${API_URL}/customer/requests/${thisRow.request_id}/reject`,
                      {},
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    )
                    .then(() => {
                      setSnackbarMessage(
                        "Request has been rejected, no email will be sent"
                      )
                      setShowSnackbar(true)
                      reload()
                    })
                    .catch((err) => {
                      alert(JSON.stringify(err))
                    })
                }

                const reset = (e) => {
                  e.stopPropagation()
                  setCompleted(params.row.id, false)
                  const thisRow = getFields(params)

                  axios
                    .post(
                      `${API_URL}/customer/requests/${thisRow.request_id}/reset`,
                      {},
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    )
                    .then(() => {
                      reload()
                    })
                    .catch((err) => {
                      alert(JSON.stringify(err))
                    })
                }

                if (params.row.completed) {
                  return (
                    <Button
                      sx={{ mx: 1 }}
                      variant="contained"
                      color="secondary"
                      onClick={reset}
                    >
                      ↺
                    </Button>
                  )
                } else {
                  return (
                    <>
                      <Button
                        sx={{ mx: 1 }}
                        variant="contained"
                        color="primary"
                        onClick={accept}
                      >
                        ✓
                      </Button>
                      <Button
                        sx={{ mx: 1 }}
                        variant="contained"
                        color="error"
                        onClick={reject}
                      >
                        ✗
                      </Button>
                    </>
                  )
                }
              },
            },
          ]}
          getRowHeight={() => "auto"} // Adjust row height dynamically
          sx={{
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal", // Allow text wrapping
              wordBreak: "break-word", // Break long words if needed
              lineHeight: "1.5", // Adjust line height for readability
            },
          }}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 25]}
          pagination
          disableRowSelectionOnClick
          checkboxSelection={false}
        />
      </div>

      <div style={{ height: 300, width: "100%" }}>


        <div style={{ height: 40, width: "100%" }}>
        </div>
        <Box
          sx={{
            marginBottom: 2,
            display: "flex",
            gap: 2,
            justifyContent: "space-between",
          }}
        >
          <p>Change Account Email</p>
        </Box>


        <TextField
          label={"Account"}
          name={"name"}
          value={account}
          variant="outlined"
          fullWidth
          sx={{
            marginBottom: "10px"
          }}
          onChange={(e) => {setAccount(e.target.value)}}
        />


        <TextField
          label="New Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          variant="outlined"
          fullWidth
          sx={{ marginBottom: "10px" }}
        />

        <Button
          variant="contained"
          color="primary"
          onClick={changeEmail}
        >
          Change Email
        </Button>

      </div>







      <Snackbar
        name="snackbar"
        open={showSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          marginTop: "13vh",
          border: "2px solid lightgray",
          borderRadius: "5px",
        }}
      >
        <Alert
          onClose={() => setShowSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>





    </div>
  )
}
